import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button, Link, Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { /* Field, */ reduxForm } from 'redux-form';

import { IncludeContent } from 'bricks/IncludeContent';
/* import { RFCheckbox } from 'bricks/ReduxForm'; */
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import commonStyles from 'styles/common.pcss';

/* import AgreementTextLink from './components/AgreementTextLink'; */
import styles from './styles.pcss';

const cx = classNames.bind({ ...styles, ...commonStyles });

class OutOfStockForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      emailError: null,
      name: '',
    };
  }

  updateEmail = (email) => {
    this.setState({ email, emailError: null });
  };

  updateName = (name) => {
    this.setState({ name });
  };

  validateEmail = () =>
    this.setState({
      emailError: this.isEmailValid() ? null : 'Неверный формат email',
    });

  handleSubmit = (event) => {
    const { email, name } = this.state;
    event.preventDefault();
    this.props.submitForm({ email, name });
  };

  isEmailValid = () => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(this.state.email);

  render() {
    const {
      /* onToogleAgreement, */
      agreementText,
      className,
      isMobile,
      outOfStockDescription,
      outOfStockHeader,
      /* isAgreementUnchecked,
      outOfStockFormName, */
    } = this.props;

    return (
      <form>
        <div className={cx('component', isMobile && 'mobile', className)}>
          {outOfStockHeader && (
            <div className={cx(isMobile && 'mobile', 'heading')}>{outOfStockHeader}</div>
          )}

          {outOfStockDescription && (
            <IncludeContent className={cx(['description'])} htmlContent={outOfStockDescription} />
          )}

          <div className={cx('row')}>
            <div className={cx('label')}>E-mail*</div>
            <div className={cx('inputWrap')}>
              <input
                className={cx('input')}
                name="outofstock-e-mail"
                onBlur={this.validateEmail}
                onChange={(e) => this.updateEmail(e.target.value || '')}
                placeholder="E-mail"
                type="text"
                value={this.state.email}
              />
            </div>
          </div>
          <div className={cx('row')}>
            <div className={cx('label')}>Имя</div>
            <div className={cx('inputWrap')}>
              <input
                className={cx('input')}
                name="outofstock-name"
                onChange={(e) => this.updateName(e.target.value || '')}
                placeholder="Имя"
                type="text"
                value={this.state.name}
              />
            </div>
          </div>
          <div className={cx('buttonWrapper')}>
            <Button
              disabled={!this.state.email || this.state.emailError}
              onClick={this.handleSubmit}
              size="l"
              type="submit"
              variant="main"
            >
              Узнать о поступлении
            </Button>
          </div>
          {agreementText && (
            <Text size="size5-r-l">
              Нажимая на кнопку, я даю свое{' '}
              <Link
                href="https://static.beeline.ru/upload/images/soglasia_27122017.pdf"
                size="size5-r-l"
                target="_blank"
              >
                согласие на обработку персональных данных.
              </Link>
            </Text>
          )}
        </div>
      </form>
    );
  }
}

OutOfStockForm.propTypes = {
  /* outOfStockFormName: PropTypes.string, */
  agreementText: PropTypes.string,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
  outOfStockDescription: PropTypes.string,
  outOfStockHeader: PropTypes.string,
  /* isAgreementUnchecked: PropTypes.bool,
  onToogleAgreement: PropTypes.func, */
  submitForm: PropTypes.func,
};

function mapStateToProps(state, props) {
  return {
    form: props.outOfStockFormName,
    initialValues: { [props.outOfStockFormName]: true },
    isMobile: isScreenBelow800(state),
  };
}

export default connect(mapStateToProps)(reduxForm({ enableReinitialize: true })(OutOfStockForm));
